// import { _removeClasses } from '../mainFunction/mainFunction'

// AboutUS
// Change the vision of persona
let imgWrapArr = document.querySelectorAll('.photo-about__image-wrap');
const personaVision = changePesonaVision(-1);
let cursorWithoutThePersonAreas = true;
personaVision();

function changePesonaVision(numberOfPersona) {
	let index = numberOfPersona;

	return function () {
		if (index < imgWrapArr.length - 1) {
			for (let index = 0; index < imgWrapArr.length; index++) {
				const element = imgWrapArr[index];
				removeClassActive(element);
			}
			index++;
			const element = imgWrapArr[index];
			if (cursorWithoutThePersonAreas) {
				addClassActive(imgWrapArr[index]);
				setTimeout(personaVision, 3000);
			}
		} else {
			removeClassActive(imgWrapArr[index]);
			index = -1;
			setTimeout(personaVision, 1500);
		}
	}
}

function addClassActive(item) {
	item.classList.add('_active');
}
function removeClassActive(item) {
	item.classList.remove('_active');
}

// check the cursor on persons area
let personsArea = document.querySelector('.photo-about__images-row');

personsArea.addEventListener("mouseenter", function (event) {
	cursorWithoutThePersonAreas = false;
});
personsArea.addEventListener("mouseleave", function (event) {
	cursorWithoutThePersonAreas = true;
	personaVision();
});
// ========================================================================